export default {"src":"/_next/static/media/check-circle.2f77486d.svg","height":64,"width":65,"blurWidth":0,"blurHeight":0};